import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  inject,
  Input,
  Output,
} from "@angular/core";
import { environment } from "src/environments/environment";
import { TableColumn } from "src/app/services/model/tables.model";

@Component({
  selector: "app-review-table-widget",
  templateUrl: "./review-table-widget.component.html",
  styleUrl: "./review-table-widget.component.scss",
  standalone: false,
})
export class ReviewTableWidgetComponent {
  @Input() showCardHeader: boolean = false;
  @Input() tableLabel: string = "APP.ITEMS";
  @Input() buttonLabel: string = "APP.ADD";
  @Input() showCardSpace: boolean = true;
  @Input() showHoverBg: boolean = true;
  @Input() rowClick: boolean = true;
  @Input() rowBorderBottom: boolean = true;
  @Input() scrollToTop: boolean = false;

  @Input() dataTable: boolean = false;

  @Input()
  set dataSource(value: any) {
    if (value) {
      this.sources = value;
    }
  }

  @Input() dataColumns: TableColumn[] = [];

  @Input() set isLoading(value: boolean) {
    this.loading = value;

    if (!this.loading && this.scrollToTop) {
      const element = document.getElementById("table_header");
      if (element) {
        element.scrollIntoView({ behavior: "smooth" }); // scroll smoothly to the element
      }
    }
  }
  @Output() onRowClick = new EventEmitter();
  @Output() onButtonClick = new EventEmitter();
  @Output() tableChange = new EventEmitter();

  loading: boolean = true;
  sources: any;

  vertical_scrollbar: boolean = false;
  fileUrl = environment.apiFileUrl;

  ngOnInit(): void {
    const table = document.getElementById("widget-table") as HTMLElement;

    if (!this.rowClick) {
      this.showHoverBg = false;
    }
  }

  objectKeyValue(prop: string | undefined) {
    return prop as string;
  }

  /** Position of `value` in the column's statuses; -1 when it is not listed (the template then falls back to muted). */
  statusIndex(index: number, value: any) {
    const column = this.dataColumns[index];
    if (this.isArray(column.statuses)) {
      return (column.statuses as number[]).findIndex(
        (status_id: number) => status_id === value
      );
    } else {
      return 0;
    }
  }
  clickedRow(data: any) {
    this.onRowClick.emit(data);
  }

  isArray(key: any) {
    return Array.isArray(key);
  }

  onTableChange(event: Event) {
    this.tableChange.emit(event);
  }
  onClick() {
    this.onButtonClick.emit(true);
  }
}
